import React, { Component } from 'react';
import './ConfirmData.css';
import Navbar from '../Components/Navbar/Navbar'
import logoblue from '../../image/logoblue.png'
import { Link } from 'react-router-dom';
import { LinkAPI } from '../../API/API';
import axios from 'axios'
import HandleRes from '../Components/HandleRes/HandleRes';


class Resetpassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      password: "",
      passwordError: ""
    }
  }
  handleChange = event => {
    const isCheckbox = event.target.type === "checkbox";
    this.setState({
      [event.target.name]: isCheckbox
        ? event.target.checked
        : event.target.value
    });
  };

  validate = () => {
    let passwordError = "";
    // let passwordError = "";

    if (this.state.password.length < 8) {
      passwordError = "write your password correct";
    }

    if (passwordError) {
      this.setState({ passwordError });
      return false;
    }

    return true;
  };
  handleSubmit = event => {
    event.preventDefault();
    const { password } = this.state
    const Token = this.props.match.params.Token 
    const isValid = this.validate();
    if (isValid) {
      axios.put(`${LinkAPI}/api/businessowner/resetpassword`,{
        password:password
      } , {
        headers: {
            Authorization: `${Token}`
        }
    }
      ).then(res =>{
       
        localStorage.setItem("userToken",res.data.token)
        localStorage.setItem("KaynuserName", res.data.businessOwner.name)
        window.location.replace("/orders");
        }).catch(error=>{
        if (!error.response) {
          this.setState({
            networkError: true
          })
        } else if (error.response.data.message) {
          this.setState({
            emailError: "",
            passwordError: "",
            errordatamessage: true,
            errordatamessagetext: error.response.data.message
          })
        } else {
          this.setState({
            hasError: true,
          })
        }
        })
    }
  };
  render() {
    document.title ="Kayn | Reset Password"; 
    document.getElementsByTagName("META")[1].content="Kayn Reset Password";
    document.documentElement.lang = 'en';
    return (
      <div className=" AppEN signin">
        <Navbar />
        <div className='container'>
          <div className="Sign row my-0 " >
            <div className=" logoform col-6 d-flex align-content-end flex-wrap ">
              <div className="col-12 text-center mt-auto p-2 bd-highlight"><Link to="/"><img className="logo" src={logoblue} alt="Kayn" /></Link>       </div>
              <p className="fontsize2 text-center mb-5 col-12">Your package...your way</p>
            </div>
            <div className="col-md-6 form float-md-right  ">
              <div className="contantform text-center p-4 mt-150">
                <h3 className="fontsize1 my-4 py-3">Reset Password </h3>
                <form className="px-lg-5" >
                 <div className="form-group mt-4 mb-1  py-3">
                    <input type="password" className={"form-control badge-pill p-3 noborder " + (this.state.passwordError ? 'is-invalid' : '')} placeholder=" password" name="password" value={this.state.password}
                      onChange={this.handleChange} required />
                    <div style={{ fontSize: 12, color: "red" }}>
                      {this.state.passwordError}
                    </div>

                  </div>
                  {(this.state.errordatamessage ?
                    <div className="px-2" style={{ fontSize: 12, color: "red" }}>
                        {this.state.errordatamessagetext}
                    </div> : '')}
                  <button onClick={this.handleSubmit} className="btn btn-primary badge-pill btn-block shadow p-2  mt-2"  >send</button>
                </form>

              </div>
            </div>
          </div>
        </div>
        {(this.state.res_sendcodedone ? <HandleRes title={this.state.resdonemessage} stylecss="alert-success" /> : '')}
        {(this.state.networkError ? <HandleRes title="You are currently offline." stylecss="alert-danger" /> : '')}
        {(this.state.hasError ? <HandleRes title="sorry there was a problem with your request" stylecss="alert-danger" /> : '')}

      </div>
    )
  }
}
export default Resetpassword;